const mapping: Record<string, string> = {
  id: 'c=>c.Id',
  userName: 'c=>c.UserName',
}

export const mapSortUserParam = (key: string) => mapping[key]
